export default __webpack_public_path__ + "static/alchem-faf63c93deb6a0a6dc0ed6b5b1c0a056.png";